import { categories, questions, details, searchResults } from './data';
import { delay } from 'Common/utils';

export const loadCategories = () => {
  return delay(500).then(
    () => {
      if(typeof categories === "undefined") {
        throw Error("kuku");
      } else {
        return categories;
      }
    }
  );
}

export const loadQuestions = (catId) => {
  return delay(500).then(
    () => {
      if(typeof questions === "undefined") {
        throw Error("kuku");
      } else {
        return questions;
      }
    }
  );
}

export const loadDetail = (id) => {
  return delay(500).then(
    () => {
      if(typeof details === "undefined") {
        throw Error("kuku");
      } else {
        return details;
      }
    }
  );
}

export const search = (searchTerm) => {
  console.log('searching for', searchTerm);
  return delay(500).then(
    () => {
      return searchResults;
    }
  );
}

export const incrementWatched = (id) => {
  console.log('incrementing', id);
  return delay(100).then(
    () => true
  );
}



// WEBPACK FOOTER //
// ./src/apps/qa/fake-api/api.js